import StatusChip from "@entrilia/shared/components/StatusChip";
import useClientContext from "../../context/useClientContext";

interface ExternalIdProps {
  externalCategoryId: string | undefined;
  categoryId?: never;
}

interface InternalIdProps {
  categoryId: string | undefined;
  externalCategoryId?: never;
}

type Props = ExternalIdProps | InternalIdProps;

const CategoryTag = ({ externalCategoryId, categoryId }: Props) => {
  const { getAccessCategoryByExternalId, getAccessCategoryById } = useClientContext();

  const category =
    categoryId !== undefined ? getAccessCategoryById(categoryId) : getAccessCategoryByExternalId(externalCategoryId);

  if (!category) {
    return null;
  }

  return <StatusChip label={category.name} color={category.effectiveColor} />;
};

export default CategoryTag;
